<template>
    <div
        class="job"
        :class="{ disabled: disabled }"
        @mouseover="hover = true"
        @mouseleave="hover = false">
        <div class="job-img"><img v-bind:src="img" /></div>
        <div class="position">{{ position }}</div>
        <div v-show="isActive" class="triangle"></div>
    </div>    
</template>

<script>
export default {
    name: 'Job',
    props: [
        'isActive', 
        'imgNormal', 
        'imgHover', 
        'position', 
        'disabled'
    ],
    data: function() {
        return{
            hover: false,
        }
    },
    computed: {
        img: function() {
            return this.isActive ? this.imgHover : this.hover ? this.imgHover : this.imgNormal;
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../static/styles/palette.scss";

    .job {
        display: inline-block;
        position: relative;
        text-align: center;
        margin: 0 10px;
        width: 170px;
        height: 270px;
        cursor: pointer;

        & .job-img {
            position: relative;
            width: 170px;

            & img {
                width: 100%;
            }
        }

        & .position {
            display: flex;
            position: relative;
            background-color: $darkGray;
            width: 100%;
            height: 40px;
            font-family: "Fugaz One";
            font-size: 13px;
            letter-spacing: 0.8px;
            color: white;
            align-items: center;
            justify-content: center;
        }

        & .triangle {
            position: absolute;
            border-style: solid;
            border-width: 30px 30px 0 30px;
            border-color: $blue transparent transparent transparent;
            bottom: 8px;
            left: calc(50% - 30px);
        }
    }

    .job.disabled {
        opacity: 0.3;
        cursor: auto;
        pointer-events: none;
    }
</style>



// WEBPACK FOOTER //
// Job.vue?06045574